import "./Dashboard.scss";
import DecisionCard from "./decision.jsx";
import StageNode from "./StageNode.jsx";
import CommentsSection from "./CommentsSection.jsx";
import ApprovalCard from "./ApprovalCard.jsx";
import React, { useState } from "react";
import { ChevronLeft } from "lucide-react";

// ─── DATA ────────────────────────────────────────────────────────────────────
const journeySteps = [
  {
    id: 1,
    title: "Application Received",
    date: "Apr 24, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Application submitted successfully,Basic details captured"
  },
  {
    id: 2,
    type: "yes",
  },
  {
    id: 3,
    type: "tat",
    tat: "TAT 2 hours",
  },
  {
    id: 4,
    title: "KYC AND AML CHECK",
    date: "Apr 24, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Aadhar Verified | PAN verified | Name match across Documents | AML / sanctions / watchlist screening"
  },
  {
    id: 5,
    type: "yes",
  },
  {
    id: 6,
    type: "tat",
    tat: "TAT 2 hours",
  },
  {
    id: 7,
    title: "Product Eligibility Check",
    date: "Apr 24, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Loan type = Personal Loan,Borrower = Salaried individual,Loan purpose allowed"
  },
  {
    id: 8,
    type: "yes",
  },
  {
    id: 9,
    type: "tat",
    tat: "TAT 2 hours",
  },
  {
    id: 10,
    title: "Target Segment Check",
    date: "Apr 24, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Employer type allowed | Not a daily wage / cash salary employee | Not restricted profession | Residence acceptable (not PG/bachelor accomodation)"
  },
  {
    id: 11,
    type: "yes",
  },
  {
    id: 12,
    type: "tat",
    tat: "TAT 30 mins",
  },
  {
    id: 13,
    title: "Age Eligibility Check",
    date: "Apr 24, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Age >= 25 years | Age <= 55 years at maturity"
  },
  {
    id: 14,
    type: "yes",
  },
  {
    id: 15,
    type: "tat",
    tat: "TAT 3 hours",
  },
  {
    id: 16,
    title: "Income Eligibility Check",
    date: "Apr 25, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Monthly salary >= ₹30,000 | Income usable as per tenure (60-70%)"
  },
  {
    id: 17,
    type: "yes",
  },
  {
    id: 18,
    type: "tat",
    tat: "TAT 2 hours",
  },
  {
    id: 19,
    title: "Employment Stability Check",
    date: "Apr 25, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Current employer vintage >= 6-12 months | Total experience >= 2 years"
  },
  {
    id: 20,
    type: "yes",
  },
  {
    id: 21,
    type: "tat",
    tat: "TAT 4 hours",
  },
  {
    id: 22,
    title: "Residence Stabibility Check",
    date: "Apr 25, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: " >= year at the current address | Rented: >= 2 years in same city"
  },
  {
    id: 23,
    type: "yes",
  },
  {
    id: 24,
    type: "tat",
    tat: "TAT 3 hours",
  },
  {
    id: 25,
    title: "Credit Bureau Check",
    date: "Apr 25, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Bureau score >= 500 | Dual bureau if loan >= ₹50,000 | No DPD > 30 days | Max 1 EMI bounce | No active SMA-2 / NPA | Max 1 EMI bounce | No active SMA-2 / NPA"
  },
  {
    id: 26,
    type: "yes",
  },
  {
    id: 27,
    type: "tat",
    tat: "TAT 1 day",
  },
  {
    id: 28,
    title: "Negative Bureau Check",
    date: "Apr 26, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Suit-filed?,Willful default?, Write-off / settlement > ₹5,0000?"
  },
  {
    id: 29,
    type: "yes",
  },
  {
    id: 30,
    type: "tat",
    tat: "TAT 6 hours",
  },
  {
    id: 31,
    title: "FOIR & Affordability Check",
    date: "Apr 26, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "FOIR <= 65-70% Minimimum post-EMI surplus available"
  },
  {
    id: 32,
    type: "yes",
  },
  {
    id: 33,
    type: "tat",
    tat: "TAT 3 hours",
  },
  {
    id: 34,
    title: "Income Validation",
    date: "Apr 26, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Salary slips verified | Salary credits visible in bank | Salary date consistent"
  },
  {
    id: 35,
    type: "yes",
  },
  {
    id: 36,
    type: "tat",
    tat: "TAT 2 hours",
  },
  {
    id: 37,
    title: "Bank Statement Analysis",
    date: "Apr 26, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Salary credit regularity|ECS/NACH bounces|Overdraft / negative balance |  Gaming / betting activity | Salary credit regularity | Suspicious debit-credit patterns"
  },
  {
    id: 38,
    type: "yes",
  },
  {
    id: 39,
    type: "tat",
    tat: "TAT 1 hour",
  },
  {
    id: 40,
    title: "Documentation Check",
    date: "Apr 27, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "PAN , Aadhar, Salary slips,Bank statement,Job ID, Address proof"
  },
  {
    id: 41,
    type: "yes",
  },
  {
    id: 42,
    type: "tat",
    tat: "TAT 1 day",
  },
  {
    id: 43,
    title: "Risk Assessment",
    date: "Apr 27, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Risk band assigment : Loan amount capped ( <= 2 * salary / ₹ 1L)"
  },
  {
    id: 44,
    type: "yes",
  },
  {
    id: 45,
    type: "tat",
    tat: "TAT 4 hours",
  },
  {
    id: 46,
    title: "Policy Deviation Check",
    date: "Apr 27, 2024",
    processedBy: "Arnav Singh",
    status: "completed",
    connector: true,
    tat: null,
    highlights: "Check if any parameter is outside policy"
  },
  {
    id: 47,
    type: "yes",
  },
  {
    id: 48,
    type: "tat",
    tat: "TAT 8 hours",
  },
  {
    id: 49,
    title: "Exceptional Approval",
    date: "Apr 28, 2024",
    processedBy: "Arnav Singh",
    status: "custom1",
    connector: true,
    tat: null,
    highlights: "Deviation note prepared , Authority approval as per level"
  },
  {
    id: 50,
    type: "no",
  },
  {
    id: 51,
    type: "tat",
    tat: "TAT 1 day",
  },
  {
    id: 52,
    title: "Credit Approval",
    date: "Apr 28, 2024",
    processedBy: "Arnav Singh",
    status: "pending",
    connector: true,
    tat: null,
    highlights: "Automated or manual approval recorded"
  },
  {
    id: 53,
    type: "yes",
  },
  {
    id: 54,
    type: "tat",
    tat: "TAT 1 day",
  },
  {
    id: 55,
    title: "Agreement & E-sign",
    date: "Apr 29, 2024",
    processedBy: "Arnav Singh",
    status: "inactive",
    connector: true,
    tat: null,
    highlights: "Digital agreement excuted"
  },
  {
    id: 56,
    type: "yes",
  },
  {
    id: 57,
    type: "tat",
    tat: "TAT 4 hours",
  },
  {
    id: 58,
    title: "Disbursement",
    date: "Apr 29, 2024",
    processedBy: "Arnav Singh",
    status: "inactive",
    connector: true,
    tat: null,
    highlights: "Funds credited to verified bank account"
  },
  {
    id: 59,
    type: "yes",
  },
  {
    id: 60,
    type: "tat",
    tat: "TAT 2 hours",
  },
  {
    id: 61,
    title: "Repayment & Monitoring",
    date: "Apr 30, 2024",
    processedBy: "Arnav Singh",
    status: "inactive",
    connector: true,
    tat: null,
    highlights: "E-NACH active , EMI reminders , Early deliquency tracking"
  },
  {
    id: 62,
    type: "yes",
  },
  {
    id: 63,
    type: "tat",
    tat: "TAT 2 hours",
  },
  {
    id: 64,
    title: "Portfolio Monitoring",
    date: "May 1, 2024",
    processedBy: "Arnav Singh",
    status: "inactive",
    connector: true,
    tat: null,
    highlights: "DPD & NPA tracking,Deviation MIS,Policy review & tightening"
  },
];

// ─── INTERMEDIATE ELEMENTS ────────────────────────────────────────────────────
function YesElement() {
  return (
    <div style={{
      padding: "10px 28px",
      borderRadius: "12px",
      background: "#ffffff",
      boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
      fontSize: "15px",
      fontWeight: 700,
      color: "#3a7d44",
      margin: "2px 0",
      textAlign: "center",
    }}>
      Yes
    </div>
  );
}

function NoElement() {
  return (
    <div style={{
      padding: "10px 28px",
      borderRadius: "12px",
      background: "#ffffff",
      boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
      fontSize: "15px",
      fontWeight: 700,
      color: "#d32f2f",
      margin: "2px 0",
      textAlign: "center",
    }}>
      No
    </div>
  );
}

function TatElement({ tat }) {
  return (
    <div style={{
      position: "relative",
      margin: "2px 0",
    }}>
      <div style={{
        padding: "8px 18px",
        borderRadius: "20px",
        background: "#fef3e2",
        color: "#b45309",
        fontSize: "13px",
        fontWeight: 500,
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
        textAlign: "center",
      }}>
        {tat}
      </div>
      <div style={{
        position: "absolute",
        left: "50%",
        top: "161%",
        width: "8px",
        height: "8px",
        borderRadius: "50%",
        backgroundColor: "white",
        border: "2px solid #a0aab4",
        transform: "translate(-50%, -50%)",
        zIndex: 1,
      }} />
    </div>
  );
}

// ─── CONNECTOR BETWEEN CARDS ─────────────────────────────────────────────────
function Connector() {
  return (
    <div style={{
      width: "2px",
      height: "10px",
      backgroundColor: "#b0bec5",
      margin: "0 auto",
      borderLeft: "2px dashed #b0bec5",
      background: "transparent",
    }} />
  );
}

// ─── MAIN DASHBOARD ──────────────────────────────────────────────────────────
export default function LoanJourneyDashboard({ handleTabs }) {
  const [activeNode, setActiveNode] = useState(null);

  function handleViewDetails(step) {
    // Don't open panels for Application Received (id: 1)
    if (step.id === 1) return;

    setActiveNode(prev => {
      // If clicking the same box, close it
      if (prev && prev.id === step.id) {
        return null;
      }
      // Otherwise, open the clicked box and close any other
      return step;
    });
  }
  return (
    <>
      <div className="container-fluid" style={{ marginTop: '50px' }}>
        <div style={{ display: 'inline-flex', gap: '7px', alignItems: 'center', cursor: 'pointer',color:'#267dff' }} onClick={()=>handleTabs("particular")}>
          <ChevronLeft style={{ width: 'auto' }} /> Back
        </div>
      </div>
      <div className="ljw">
        <div className="ljw__header">
          <h1 className="ljw__title">Credit Decision Journey</h1>
          <p className="ljw__subtitle">Application ID: #APP-2024-892</p>
        </div>

        <div className="ljw__layout" style={{
          display: "flex",
          alignItems: "flex-start",
          position: "relative"
        }}>
          {/* LEFT — Decision Card */}
          <div style={{
            position: "absolute",
            left: "max(1vw, 8px)",
            top: "-100px",
            width: "min(300px, 25vw)",
            zIndex: 1
          }}>
            <DecisionCard />
          </div>

          {/* CENTER — Timeline Container */}
          <div style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            width: "100%",
            marginLeft: "max(-2vw, -25px)"
          }}>
            {/* Timeline */}
            <div className="timeline" style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "0px",
              flex: 1,
            }}>
              {journeySteps.map((step, index) => {
                if (step.type === "yes") {
                  return (
                    <div key={step.id}>
                      <Connector />
                      <YesElement />
                      <Connector />
                    </div>
                  );
                }

                if (step.type === "no") {
                  return (
                    <div key={step.id}>
                      <Connector />
                      <NoElement />
                      <Connector />
                    </div>
                  );
                }

                if (step.type === "tat") {
                  return (
                    <div key={step.id}>
                      <Connector />
                      <TatElement tat={step.tat} />
                      <Connector />
                    </div>
                  );
                }

                return (
                  <div key={step.id} style={{ position: "relative" }}>
                    {index > 0 && step.connector && <Connector />}
                    <div
                      onClick={() => handleViewDetails(step)}
                      style={{ cursor: step.id === 1 ? "default" : "pointer" }}
                    >
                      <StageNode
                        title={step.title}
                        date={step.date}
                        status={step.status}
                        tat={step.tat}
                        connector={step.connector}
                        processedBy={step.processedBy}
                        active={activeNode && activeNode.id === step.id}
                        disableHover={step.id === 1}
                      />
                    </div>

                    {/* Panels for this specific box */}
                    {activeNode && activeNode.id === step.id && (
                      <React.Fragment key={`panels-${activeNode.id}`}>
                        {/* Connecting line to left panel */}
                        <svg
                          width="370"
                          height="200"
                          viewBox="0 0 370 200"
                          fill="none"
                          style={{
                            position: "absolute",
                            right: "113px",
                            top: "20px",
                            zIndex: 0,
                            pointerEvents: "none"
                          }}
                        >
                          <line x1="370" y1="40" x2="6" y2="40" stroke="#a0aab4" strokeWidth="3.5" strokeDasharray="7,6" strokeLinecap="round" />
                        </svg>

                        {/* Left side - Comments Panel */}
                        <div style={{
                          position: "absolute",
                          right: "clamp(350px, 35vw, 450px)",
                          top: "0",
                          width: "clamp(350px, 20vw, 400px)",
                          zIndex: 1
                        }}>
                          <CommentsSection />
                        </div>

                        {/* Connecting line to right panel */}
                        <svg
                          width="370"
                          height="200"
                          viewBox="0 0 370 200"
                          fill="none"
                          style={{
                            position: "absolute",
                            left: "113px",
                            top: "20px",
                            zIndex: 0,
                            pointerEvents: "none"
                          }}
                        >
                          <line x1="0" y1="40" x2="364" y2="40" stroke="#a0aab4" strokeWidth="3.5" strokeDasharray="7,6" strokeLinecap="round" />
                        </svg>

                        {/* Right side - Approval Panel */}
                        <div style={{
                          position: "absolute",
                          left: "clamp(350px, 35vw, 450px)",
                          top: "0",
                          width: "clamp(350px, 20vw, 400px)",
                          zIndex: 1
                        }}>
                          <ApprovalCard step={step} highlights={step.highlights} />
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}